export default "__VITE_ASSET__CvkA7hbm__"